import { Injectable, Input } from '@angular/core';
import * as SecureLS from 'node_modules/secure-ls/dist/secure-ls';
import { Location } from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export class SessionService {
    private ls = new SecureLS({ encodingType: 'aes' });

    constructor(private location: Location) {}

    // NOTE Getters
    get token(): any {
        return this.ls.get('token').data;
    }

    get role(): any {
        return this.ls.get('role').data;
    }

    get id(): any {
        return this.ls.get('id').data;
    }

    // NOTE Setters
    set token(token: any) {
        this.ls.set('token', { data: token });
    }

    @Input()
    set role(role: any) {
        this.ls.set('role', { data: role });
    }

    @Input()
    set id(id: any) {
        this.ls.set('id', { data: id });
    }

    logOff(): void {
        this.role === 'ROLE_PARTICIPANTE'
            ? this.location.go('/participante/login')
            : this.location.go('');
        localStorage.clear();
        sessionStorage.clear();
        location.reload();
    }
}
